import {API, Setup} from '../../Services';

async function orderPickerOrders_api(page=1){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/order-picker/orders?page=${page}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function orderPickerAcceptOrder_api(orderId){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}/accept`,{},{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function orderPickerOrderDetail_api(orderId){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


async function orderPickerOrderChangeQuantity_api(orderId,obj){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}/items/change_quantity/`,obj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function bulkUpdateOrderItmesPickedQuantityWithOrderPicker_api(orderId,obj){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    let list = [obj]
    return API.put(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}/items`,list,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


async function orderPickerUpdatePickedQuantity_api(orderId,productId,obj){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.put(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}/items/${productId}`,obj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function updateOrderWithOrderPicker_api(orderId,obj){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.put(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}`,obj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function picking_done_api(orderId,obj){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`merchant_admin/${merchantId}/order-picker/orders/${orderId}/picking/done`,obj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function finalizeOrderWithOrderPicker_api(orderId,obj){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}/finalize`,obj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}



async function orderPickerOrderBulkAddProduct_api(orderId,obj){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}/items/bulk_add`,obj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function orderPickerUpdateOrderRowQuantity_api(orderId,obj){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/order-picker/orders/${orderId}/items/bulk_add`,obj,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


async function StoreOnlineSearch(search,page=1){
    let token =  localStorage.getItem('token');
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/shop/${merchantId}/product/?search=${search}&page=${page}`,{headers: { 'Authorization':  `Bearer ${token}`}});
}



async function orderPickerArchivedOrders_api(page=1,status="",search=""){
    let token =  localStorage.getItem('token');
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/order-picker/orders/archived?&page=${page}&search=${search}&status=${status}`,{headers: { 'Authorization':  `Bearer ${token}`}});
}


async function list(page=1,status="",search=""){
    let token =  localStorage.getItem('token');
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/order-picker/orders/archived?&page=${page}&search=${search}&status=${status}`,{headers: { 'Authorization':  `Bearer ${token}`}});
}


async function merchants_api(){
    let token =  localStorage.getItem('token');
    return API.get(`/users/merchant-orders`,{headers: { 'Authorization':  `Bearer ${token}`}});
}


async function sidePermission_api(mId){
    let token =  localStorage.getItem('token');
    return API.get(`/merchant_admin/${mId}/admin/user/panel-pages`,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function permission_api(){
    let token =  localStorage.getItem('token');
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/admin/user/panel-pages`,{headers: { 'Authorization':  `Bearer ${token}`}});
}

export {
    sidePermission_api,
    permission_api,
    merchants_api,
    orderPickerOrders_api,
    orderPickerAcceptOrder_api,
    orderPickerOrderDetail_api,
    orderPickerOrderChangeQuantity_api,
    bulkUpdateOrderItmesPickedQuantityWithOrderPicker_api,
    updateOrderWithOrderPicker_api,
    orderPickerUpdatePickedQuantity_api,
    finalizeOrderWithOrderPicker_api,
    StoreOnlineSearch,
    orderPickerOrderBulkAddProduct_api,
    orderPickerArchivedOrders_api,
    picking_done_api,
    orderPickerUpdateOrderRowQuantity_api
};
